// export const API_URL = "https://lims.londonhealthcompany.co.uk/backend/api/";
// export const BACKEND_URL = "https://lims.londonhealthcompany.co.uk/backend/";
// //
// export const API_URL = "http://localhost/lims-laravel-github/api/";
// export const BACKEND_URL = "http://localhost/lims-laravel-github/";

// const BACKEND_BASE = "http://localhost/lims-laravel/";
const BACKEND_BASE = "https://api-lims.v.pr/public/";

// Always use the Laravel API URL (WAMP). CORS is enabled on the backend (config/cors.php).
export const API_URL = `${BACKEND_BASE}api/`;
export const BACKEND_URL = BACKEND_BASE;
